// ─── Permission modules & their available actions ─────────────────────────────
// Used by ManagePermissionRoles and hasPermission()
export const PERMISSION_MODULES = {
  dashboard:    { label: 'Dashboard',     icon: 'LayoutDashboard', actions: ['view'] },
  rooms:        { label: 'Rooms',         icon: 'Home',            actions: ['view', 'create', 'edit', 'delete'] },
  bookings:     { label: 'Bookings',      icon: 'Calendar',        actions: ['view', 'update_status', 'update_payment', 'cancel'] },
  commissions:  { label: 'Commissions',   icon: 'DollarSign',      actions: ['view', 'mark_paid'] },
  reports:      { label: 'Reports',       icon: 'BarChart2',       actions: ['view'] },
  gallery:      { label: 'Gallery',       icon: 'Image',           actions: ['view', 'upload', 'edit', 'delete'] },
  site_content: { label: 'Site Content',  icon: 'FileText',        actions: ['view', 'edit'] },
  contacts:     { label: 'Contacts',      icon: 'MessageSquare',   actions: ['view', 'delete'] },
  portal_users: { label: 'Portal Users',  icon: 'Shield',          actions: ['view', 'create', 'edit', 'delete'] },
};

export const ACTION_LABELS = {
  view:           'View',
  create:         'Create',
  edit:           'Edit',
  delete:         'Delete',
  upload:         'Upload',
  update_status:  'Update Status',
  update_payment: 'Update Payment',
  cancel:         'Cancel',
  mark_paid:      'Mark Paid',
};

export const USER_TYPES = {
  CUSTOMER: 'customer',
  AGENT: 'agent',
  OWNER: 'owner',
};

export const BOOKING_STATUS = {
  PENDING: 'pending',
  CONFIRMED: 'confirmed',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed',
};

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  PAID: 'paid',
  REFUNDED: 'refunded',
  FAILED: 'failed',
};

export const ROOM_STATUS = {
  AVAILABLE: 'available',
  OCCUPIED: 'occupied',
  MAINTENANCE: 'maintenance',
};

export const MESSAGES = {
  SUCCESS: {
    LOGIN: 'Login successful!',
    REGISTER: 'Registration successful!',
    BOOKING_CREATED: 'Booking created successfully!',
  },
  ERROR: {
    LOGIN_FAILED: 'Login failed. Please check your credentials.',
    NETWORK_ERROR: 'Network error. Please check your connection.',
  },
};

export const CURRENCY = {
  SYMBOL: '₹',
  CODE: 'INR',
};